import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a9ac30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content tariff-notification-modal__content" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "modal-body tariff-notification-modal__body" }
const _hoisted_4 = { class: "row align-items-center tariff-notification-modal__row" }
const _hoisted_5 = {
  key: 0,
  class: "col-auto tariff-notification-modal__image-col"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col tariff-notification-modal__content-col" }
const _hoisted_8 = {
  key: 0,
  class: "tariff-notification-modal__button-wrapper"
}

import { ref, onMounted, onUnmounted } from 'vue';

interface Props {
    title: string;
    imageUrl?: string;
    buttonText?: string;
    secondaryButtonText?: string;
    maxWidth: number;
    /** Запретить закрытие модалки: крестиком, Escape и кликом по фону */
    blockClose?: boolean;
    /**
     * Без кнопок внизу (закрытие — крестиком). Пустой слот footer для этого не подходит:
     * Vue считает его незаданным и рендерит кнопку по умолчанию («Узнать подробнее»)
     */
    withoutButtons?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TariffNotificationModal',
  props: {
    title: {},
    imageUrl: { default: '' },
    buttonText: { default: 'Узнать подробнее' },
    secondaryButtonText: { default: '' },
    maxWidth: { default: 671 },
    blockClose: { type: Boolean, default: false },
    withoutButtons: { type: Boolean, default: false }
  },
  emits: ["shown", "hidden", "buttonClick", "secondaryButtonClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const modalElement = ref<HTMLElement | null>(null);
let modalApi: typeof window.bootstrap.Modal = null;
let isProgrammaticHide = false;

const initModal = () => {
    if (!modalElement.value) return;
    modalApi = new window.bootstrap.Modal(modalElement.value, {
        backdrop: true,
        keyboard: true,
    });
    // hide.bs.modal отменяем — это разом закрывает крестик, Escape и клик по фону.
    // Владелец модалки закрывает её через hide() — такое закрытие пропускаем всегда,
    // иначе после списания окно останется висеть: prop blockClose обновится только
    // на следующем тике, а hide() зовётся в том же.
    modalElement.value.addEventListener('hide.bs.modal', (e: Event) => {
        if (isProgrammaticHide) {
            isProgrammaticHide = false;
            return;
        }

        if (props.blockClose) {
            e.preventDefault();
        }
    });
    modalElement.value.addEventListener('shown.bs.modal', () => emit('shown'));
    modalElement.value.addEventListener('hidden.bs.modal', () => emit('hidden'));
};

const show = () => {
    isProgrammaticHide = false;
    modalApi?.show();
};
const hide = () => {
    isProgrammaticHide = true;
    modalApi?.hide();
};
const onButtonClick = () => emit('buttonClick');
const onSecondaryButtonClick = () => emit('secondaryButtonClick');

onMounted(initModal);
onUnmounted(() => {
    if (modalApi && modalElement.value) modalApi.dispose?.();
});

__expose({ show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade tariff-notification-modal",
    tabindex: "-1",
    ref_key: "modalElement",
    ref: modalElement,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: "modal-dialog modal-dialog-centered",
      style: _normalizeStyle({
            maxWidth: `${_ctx.maxWidth + 32}px`
        })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close tariff-notification-modal__close",
          "aria-label": "Закрыть",
          disabled: _ctx.blockClose,
          onClick: hide
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.imageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "image", {}, () => [
                    (_ctx.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.imageUrl,
                          class: "tariff-notification-modal__image",
                          alt: "Иллюстрация"
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h3", {
                class: _normalizeClass(["tariff-notification-modal__title pb-1 mb-2", {
                                    'tariff-notification-modal__title--without-image': !_ctx.imageUrl,
                                }])
              }, _toDisplayString(_ctx.title), 3),
              _renderSlot(_ctx.$slots, "default"),
              (!_ctx.withoutButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("button", {
                        class: "btn btn-primary tariff-notification-modal__button px-4 py-1 py-md-2",
                        onClick: onButtonClick
                      }, _toDisplayString(_ctx.buttonText), 1),
                      (_ctx.secondaryButtonText)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-outline-primary tariff-notification-modal__button tariff-notification-modal__button--secondary px-4 py-1 py-md-2",
                            onClick: onSecondaryButtonClick
                          }, _toDisplayString(_ctx.secondaryButtonText), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ], 4)
  ], 512))
}
}

})